import React, { useState } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";

const SignIn = () => {
	// checkbox
	const [isChecked, setIsChecked] = useState(false);

	const handleCheckboxChange = (e) => {
		const checked = e.target.checked;
		setIsChecked(checked);
		console.log(`Checkbox is ${checked ? "checked" : "unchecked"}`);
	};

	return (
		<>
			<div className="main-banner-heading1">
				<Header />
			</div>
			<section className="signin">
				<div className="container">
					<div className="row">
						<div className="col-lg-6 mx-auto">
							<div className="main-bg-signin">
								<h2 className="main-heading level-2 text-center mt-3 mb-3 main-heading-font dark-color wow animate__animated animate__zoomIn">
									Sign In
								</h2>
								<div className="row">
									<div className="col-lg-12 mb-2">
										<div class="form-group">
											<h5 class="primary-medium-font level-7 ">Email</h5>
											<input
												type="text"
												className="form-control"
												id="firstName"
												placeholder="Enter Email"
											/>
										</div>
									</div>
									<div className="col-lg-12">
										<div class="form-group">
											<h5 class="primary-medium-font level-7 ">Password</h5>
											<input
												type="password"
												className="form-control"
												id="firstName"
												placeholder=" Enter Password"
											/>
										</div>
									</div>
									<div className="row mt-3 ">
										<div className="col-lg-6">
											<div className="container-wrapper-access container-wrapper-access1">
												<label className="custom-checkbox">
													<input
														type="checkbox"
														checked={isChecked}
														onChange={handleCheckboxChange}
													/>
													<span className="checkmark "></span>
													<h4 className="primary-medium-font level-7  mb-0 ">
														{" "}
														Remember me
													</h4>
												</label>
											</div>
										</div>
										<div className="col-lg-6  text-end">
											<Link
												className="header-link level-7 link-here primary-medium-font  extra-color-1"
												to="/forget-password"
											>
												<h4 className="primary-medium-font level-7 text-decoration-none  mb-0 ">
													{" "}
													Forgot Password
												</h4>
											</Link>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-lg-12">
										<Link
											class="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
											to="/user-signup"
										>
											<span class="bg-wrapper w-100">Sign In</span>
										</Link>
									</div>
									<div className="col-lg-12">
										<h4 class=" level-7 text-center mt-3  primary-regular-font text-decoration-none extra-color-1">
											Don’t have an Account?{" "}
											<Link
												class="header-link level-7 link-here primary-medium-font text-decoration-none extra-color-1"
												to="/user-signup"
											>
												Sign Up
											</Link>
										</h4>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default SignIn;
